export default "__VITE_ASSET__KrMPfk13hYyF3bdfbXFwJA__"